import type { ShopBankTransferRepository } from "../../../domain/repositories/shop/shop-bank-transfer-repository";
import type { BankTransferEntity } from "../../../domain/types/company-bank-transfer";
import { shopBankTransferApiService } from "../../api/shop/shop-bank-transfer-api-service";

export class ShopBankTransferRepositoryImpl
  implements ShopBankTransferRepository
{
  async getBankTransfers(shopId: number): Promise<BankTransferEntity[]> {
    const response = await shopBankTransferApiService.getBankTransfers(shopId);

    if (response.data) {
      return response.data;
    }

    throw new Error(response.errorMsg || "최근 둘러본 상품 가져오기 실패.");
  }
}
